const styles = (theme) => ({
  paperContainer: {
    width: "100%",
    display: "flex",
    p: 2,
    borderRadius: "16px",
    flexDirection: "column",
    gap: 2,
    position: "relative",
  },
  linearProgress: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    zIndex: 1,
  },
  boxLoading: {
    position: "relative",
    overflow: "hidden",
    borderRadius: "16px",
    height: 30,
  },
  headerRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "10px",
  },
  boxTitle: {
    display: "flex",
    gap: 1,
    alignItems: "center",
  },
  containerIconCard: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "30px",
    height: "30px",
    borderRadius: "5px",
  },
  icon: {
    height: 22,
    width: 22,
    color: theme.palette.white.main,
  },
  iconImg: {
    height: 22,
    width: 22,
  },
  cardSubText: {
    fontWeight: 500,
    fontSize: "20px",
    mb: 0.4,
    "@media (max-width: 600px)": {
      fontSize: "16px",
      mb: 0.1,
    },
  },
  boxGraph: { width: "100%", height: 110 },
  historyButton: {
    color: theme.palette.text.secondary,
  },
});

export default styles;
